import React from 'react'
import TopBar from '../bars/top-bar'
import BackIconButton from '../buttons/BackIconButton'
import HeadingBeta from '../headings/heading-beta'
import InfoBlock from '../texts/info-block'

const AboutUs = props => {
  return (
    <div className='detail-item inner-wrapper-wide'>
      <TopBar
        theme='light-bar'
        leftChildren={[<BackIconButton key='BackIconButton' />]}
      />
      <HeadingBeta className='bottom-space'>About us</HeadingBeta>
      <InfoBlock>
        <p>
          Throughout my adult life, I attended many fund raising events for many
          different charities. These events ranged from sporting events, black
          tie galas, concerts, golf tournaments, etc. The vast majority of these
          events included either a live or silent auction where attendees could
          bid on anything from sports memorabilia, celebrity experiences, golf
          packages, trips, jewelry, sporting events, etc. I found that almost
          all of the items that were auctioned, sold for substantially less than
          their actual value. When I was approached with the opportunity to
          Chair the Boy Scouts of America’s annual golf event I jumped in with
          both feet. However, I ran into the same problem. I quickly realized
          that It wasn’t about the auction items, or the people who were bidding
          on them, but it was about being able to advertise and expose these
          items to far more people over a significantly larger time frame. I
          immediately called two friends that have been involved in working for
          and raising money for charities for far longer than I had been, to get
          their point of view. We all agreed that charities could be raising far
          more money, with less effort. We created Chair-bids to help them do
          it.
        </p>
        <p>
          Chair-bids allows accredited charities to advertise, not only auction
          items, but their event as well, to the public or a private audience of
          their choice. It also allows charities to receive monetary donations
          as well as donated auction items to help maximize their events’
          success. It also allow users to be able to participate in charity
          events they wouldn’t otherwise be able to attend, by enabling the
          users to bid on items that have previously only been offered to people
          attending the event.
        </p>
        <p>
          By creating Chair-bids, our hope is to increase charitable donations
          and maximize the success of the events charities run that are vital to
          their success. We also hope to give users the opportunity to
          participate and experience unique opportunities they wouldn’t normally
          be able to experience. Robert Floyd C.E.O.
        </p>
        <p>Robert Floyd C.E.O.</p>
      </InfoBlock>
    </div>
  )
}

export default AboutUs



// WEBPACK FOOTER //
// ./src/ui/views/about-us.js